import { ArrowLeft } from "lucide-react";

const BackButton = ({ handleClick }) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <button
        type="button"
        className="btn btn-primary btn-sm d-flex align-items-center gap-1"
        onClick={handleClick}
      >
        <ArrowLeft size={16} />
        Back
      </button>
    </div>
  );
};

export default BackButton;